import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useCombinedStore } from "../store";
import Modal from "react-modal";
import api from "../services/api.service";
import * as Styles from "../styles/PartialWithdrawal.Modal.styles";
import alfredoIcon from "../assets/alfredo-icon.svg";

const PartialWithdrawalModal: React.FC<{
  isOpen: boolean;
  onRequestClose: () => void;
}> = ({ isOpen, onRequestClose }) => {
  const {
    subsidiaryDataZustand,
    setOrderDataZustand,
    orderDataZustand,
    authUserZustand,
    setMessageZustand,
  } = useCombinedStore((state) => {
    return {
      setSubsidiaryDataZustand: state.setSubsidiaryDataZustand,
      subsidiaryDataZustand: state.subsidiaryDataZustand,
      setOrderDataZustand: state.setOrderDataZustand,
      orderDataZustand: state.orderDataZustand,
      setMessageZustand: state.setMessageZustand,
      authUserZustand: state.authUserZustand,
    };
  });
  const { saleOption } = useParams();
  const selectedSaleOption =
    subsidiaryDataZustand.selectedPdv.saleOptions.filter(
      (item) => item.itemInfoUuid === saleOption
    )[0];

  const [partialwithdrawalValue, setPartialwithdrawalValue] = useState("");
  const [partialwithdrawalReason, setPartialwithdrawalReason] = useState("");
  const periodBalance = subsidiaryDataZustand?.selectedPdv?.selectedPeriod?.periodInfo?.periodBalance;
  const modalWrapperRef = useRef<HTMLDivElement>(null);

  const handleSubmit = async () => {
    if (!partialwithdrawalValue) {
      setMessageZustand(`Valor do Retiro é obrigatório!`, `error`);
      return;
    }
    else if (Number(partialwithdrawalValue) > parseFloat(periodBalance?.replace(",", "."))) {
      setMessageZustand(`Valor do Retiro é maior que o saldo disponível!`, `error`);
      return;
    }
    else if (!partialwithdrawalReason) {
      setMessageZustand(`Motivo do Retiro é obrigatório!`, `error`);
      return;
    }
    try {
      api.post(
        `/partialwithdrawal/${subsidiaryDataZustand.selectedPdv.selectedPeriod.periodUuid}/${selectedSaleOption?.itemInfoValue.saleOptionPrinterAddress}`,
        {
          periodInfoValue: Number(partialwithdrawalValue),
          reason: partialwithdrawalReason || "Sem motivo",
        }
      );

      setMessageZustand(`Retiro realizado com sucesso!`, `success`);
      setPartialwithdrawalValue("");
      setPartialwithdrawalReason("");
      onRequestClose();
    } catch (error: any) {
      if (error.message === "Network Error") {
        setMessageZustand(
          `Erro ao tentar alterar status da conta, entre em contato com os administradores do Alfredo da sua unidade.`,
          `error`
        );
      } else {
        setMessageZustand(
          `Erro ao alterar status da conta: ${error.message}`,
          `error`
        );
      }
    }
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => onRequestClose()}
      style={Styles.customStyles}
      contentLabel="Main Modal"
      ariaHideApp={false}
    >
      <Styles.ModalWrapper
        tabIndex={-1}
        ref={modalWrapperRef}
        onKeyDown={handleKeyDown}
      >
        <Styles.CloseButton onClick={() => onRequestClose()}>
          &times;
        </Styles.CloseButton>
        <Styles.ModalContent>
          <Styles.ModalHeader
            color={
              subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                .buttonsColor
            }
          >
            <Styles.Logo src={alfredoIcon} alt="Alfredo Web OPS" />
            <Styles.ModalTitle>Retiro Parcial</Styles.ModalTitle>
            <Styles.ModalDescription>
              Realize uma retirada de valor físico deste ponto de venda.
            </Styles.ModalDescription>
          </Styles.ModalHeader>
          <Styles.ModalBody
            color={
              subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                .buttonsColor
            }
          >
            <Styles.FieldCashContainer>
              <Styles.NumberCashInput
                color={
                  subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                    .buttonsColor
                }
              >
                <input
                  type="number"
                  placeholder=""
                  value={partialwithdrawalValue}
                  onChange={(e) => setPartialwithdrawalValue(e.target.value)}
                  onKeyPress={handleKeyPress}
                />
                <label>Valor do Retiro:</label>
              </Styles.NumberCashInput>
              <Styles.UnitCash
                color={
                  subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                    .buttonsColor
                }
              >
                R$
              </Styles.UnitCash>
            </Styles.FieldCashContainer>
            <Styles.FieldCashContainer>
              <Styles.NumberCashInput
                color={
                  subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                    .buttonsColor
                }
              >
                <input
                  type="number"
                  placeholder=""
                  value={Number(periodBalance?.replace(",", ".")).toFixed(2)}
                  readOnly={true}
                  onKeyPress={handleKeyPress}
                />
                <label>Saldo Disponível:</label>
              </Styles.NumberCashInput>
              <Styles.UnitCash
                color={
                  subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                    .buttonsColor
                }
              >
                R$
              </Styles.UnitCash>
            </Styles.FieldCashContainer>
            <Styles.FieldCashContainer>
              <Styles.TextInput
                color={
                  subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                    .buttonsColor
                }
              >
                <input
                  type="text"
                  placeholder=""
                  value={partialwithdrawalReason}
                  onChange={(e) => setPartialwithdrawalReason(e.target.value)}
                  onKeyPress={handleKeyPress}
                />
                <label>Motivo do Retiro:</label>
              </Styles.TextInput>
            </Styles.FieldCashContainer>
          </Styles.ModalBody>
          <Styles.ModalFooter
            color={
              subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                .buttonsColor
            }
          >
            <Styles.Button onClick={() => {
              setPartialwithdrawalValue("");
              setPartialwithdrawalReason("");
              onRequestClose()
            }}>
              Cancelar
            </Styles.Button>
            <Styles.Button onClick={handleSubmit}>Retirar</Styles.Button>
          </Styles.ModalFooter>
        </Styles.ModalContent>
      </Styles.ModalWrapper>
    </Modal>
  );
};

export default PartialWithdrawalModal;

